import { ConsentClient } from "@datos-protegidos/consent-sdk-browser";
import type { PublicConfig, WidgetOptions } from "./types";

export async function fetchPublicConfig(opts: WidgetOptions): Promise<PublicConfig> {
  const url = `${opts.baseUrl.replace(/\/$/, "")}/public-config?key=${encodeURIComponent(opts.publishableKey)}`;
  const res = await fetch(url, { mode: "cors" });
  if (!res.ok) throw new Error(`public_config_error:${res.status}`);
  return (await res.json()) as PublicConfig;
}

function client(opts: WidgetOptions): ConsentClient {
  return new ConsentClient({ publishableKey: opts.publishableKey, baseUrl: opts.baseUrl, language: opts.lang ?? "es-CL" });
}

export async function recordCategory(opts: WidgetOptions, cookieId: string, purposeIds: string[]): Promise<string[]> {
  const c = client(opts);
  const results = await Promise.all(
    purposeIds.map((purposeId) =>
      c.recordConsent({
        subject: { cookieId },
        purposeId,
        consentMethod: "explicit_clickwrap",
        context: { pageUrl: typeof location !== "undefined" ? location.href : undefined },
      }),
    ),
  );
  return results.map((res) => res.record.id);
}

export async function withdrawRecords(opts: WidgetOptions, recordIds: string[]): Promise<void> {
  const c = client(opts);
  for (const id of recordIds) {
    await c.withdraw(id);
  }
}
